module.exports = __webpack_public_path__ + "img/linea_a_1m.5fca246f.gif";